import React, { useEffect, useState } from 'react';
import { logger } from '@fiverr-private/obs';

// eslint-disable-next-line react/display-name
export const withAfp1Observer = (WrappedComponent) => (props) => {
    const [afp1, setAfp1] = useState('');

    useEffect(() => {
        window.addEventListener('message', onMessageHandler(setAfp1));
        window.addEventListener('load', onLoadHandler, false);

        return () => {
            window.removeEventListener('message', onMessageHandler);
            window.removeEventListener('load', onLoadHandler, false);
        };
    }, []);

    return <WrappedComponent {...props} afp1={afp1} />;
};

const onMessageHandler = (setAfp1) => (event) => {
    // @TODO
    // need to add event identifier, to filter out not relevant events
    // current implementation going to catch all parent post massages
    try {
        if (event.data.url) {
            setAfp1(event.data.url);
        } else {
            // logger.info('Empty afp1 was passed from affiliate website.');
        }
    } catch {
        logger.info('Error in validating afp1 parameter in gigs_widget', { data: event.data });
    }
};

const onLoadHandler = () => {
    setTimeout(() => {
        window.top.postMessage('ready', '*');
    }, 2000); // iframe script loads asynchronously
};
